module.exports = __webpack_public_path__ + "img/settings-nav-selected.784b4dfc.svg";